interface StickyBottomBarProps {
  onNextStep: (items: any) => void;
  onPrevStep: () => void;
  prevLabel?: string;
  nextLabel?: string;
  disableNext?: boolean;
  disablePrev?: boolean;
  hidePrev?: boolean;
}
const StickyBottomBar: React.FC<StickyBottomBarProps> = ({
  onNextStep,
  onPrevStep,
  prevLabel,
  nextLabel,
  disableNext,
  disablePrev,
  hidePrev = false,
}) => {
  return (
    <div className="z-[60] fixed bottom-0 left-0 right-0 bg-white shadow-2xl border-t border-gray-200">
      <div className="px-4 sm:px-14 py-4 flex justify-end items-center gap-1">
        {!hidePrev && <button
          type="button"
          onClick={onPrevStep}
          disabled={disablePrev}
          className={`px-6 py-2 border border-gray-300 text-gray-700 rounded-full text-lg font-medium
                        ${disablePrev ? 'cursor-not-allowed bg-gray-200 text-gray-500' : 'bg-white hover:bg-gray-50'} transition duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500`}
        >
          {prevLabel ?? 'กลับ'}
        </button>}
        <button
          type="button"
          onClick={onNextStep}
          disabled={disableNext}
          data-cy="next-step-button"
          className="px-3 sm:px-6 py-2 bg-blue-600 text-white rounded-full text-lg font-medium
                                 hover:bg-blue-700 transition duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          {nextLabel ?? 'ตรวจสอบ'}
        </button>
      </div>
    </div>
  );
};

export default StickyBottomBar;
